import { useState, useEffect } from "react";

import { Assignment } from "@/types/models/Assignment.interface";
import { UserProperties } from "@/types/models/UserProperties.interface";

const useAssignmentEmbedVisibility = (
  latestAssignment: Assignment,
  userProperties: UserProperties,
) => {
  const [isStudentAssignmentEmbedActive, setIsStudentAssignmentEmbedActive] =
    useState(false);
  const { isStudent } = userProperties;

  useEffect(() => {
    // If the latest assignment was not created in the new curations MVE
    // latestAssignment will be null
    const shouldSetEmbedActive = isStudent && latestAssignment;

    if (shouldSetEmbedActive) {
      setIsStudentAssignmentEmbedActive(true);
    }
  }, [latestAssignment]);

  return [isStudentAssignmentEmbedActive, setIsStudentAssignmentEmbedActive];
};

export default useAssignmentEmbedVisibility;
